class ShopIconsSlider {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.carousel = section.querySelector('[data-section-carousel]');
    this.prevButton = section.querySelector('[data-slider-prev]');
    this.nextButton = section.querySelector('[data-slider-next]');
    this.mobileLayout = section.dataset.mobileLayout;

    this.flickityInstance = null;
    this.isInitialized = false;

    this.init();
    this.bindEvents();
  }

  init() {
    this.handleResponsive();
  }

  initFlickity() {
    if (!this.carousel || this.isInitialized) return;

    if (typeof Flickity === 'undefined') {
      console.error('Flickity is not loaded.');
      return;
    }

    const width = window.innerWidth;
    const isMobile = width < 768;
    const isSmallMobile = width <= 500;

    this.flickityInstance = new Flickity(this.carousel, {
      cellAlign: isSmallMobile ? 'center' : 'left',
      contain: isSmallMobile ? true : !isMobile,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      draggable: true,
      accessibility: true,
      groupCells: isSmallMobile ? 1 : false,
      freeScroll: isSmallMobile ? false : true,
      friction: isSmallMobile ? 0.6 : 0.8,
      selectedAttraction: isSmallMobile ? 0.15 : 0.1,
      setGallerySize: true,
      resize: true,
      watchCSS: false
    });

    this.isInitialized = true;
  }

  destroyFlickity() {
    if (this.flickityInstance && this.isInitialized) {
      this.flickityInstance.destroy();
      this.flickityInstance = null;
      this.isInitialized = false;
    }
  }

  handleResponsive() {
    const isMobile = window.innerWidth < 768;

    if (isMobile && this.mobileLayout === 'stack') {
      this.destroyFlickity();
    } else {
      if (!this.isInitialized) {
        this.initFlickity();
      } else {
        // Re-init if breakpoint changes
        this.destroyFlickity();
        this.initFlickity();
      }
    }
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.flickityInstance?.previous();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.flickityInstance?.next();
      });
    }
    
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.handleResponsive();
      }, 300);
    });

    // Keyboard navigation
    this.carousel?.addEventListener('keydown', (e) => {
      if (!this.flickityInstance) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.flickityInstance.previous();
      }

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.flickityInstance.next();
      }
    });
  }

  refresh() {
    if (this.flickityInstance) {
      this.flickityInstance.resize();
      this.flickityInstance.reloadCells();
    }
  }

  destroy() {
    this.destroyFlickity();
  }
}

/* ----------------------------------------
   Initialize all sliders
---------------------------------------- */

function initShopIconsSliders() {
  document
    .querySelectorAll('.shop-icons-slider')
    .forEach(section => new ShopIconsSlider(section));
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', initShopIconsSliders)
  : initShopIconsSliders();

/* ----------------------------------------
   Shopify Theme Editor Support
---------------------------------------- */

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.shop-icons-slider');
    if (section) new ShopIconsSlider(section);
  });

  document.addEventListener('shopify:section:reorder', (e) => {
    const section = e.target.querySelector('.shop-icons-slider');
    if (section) {
      const instance = new ShopIconsSlider(section);
      instance.refresh();
    }
  });
}
